module.exports = __webpack_public_path__ + "img/blocSWAP.bd78390b.png";